import React from 'react';
import Image, { getMapToRatios, getVariantUrls } from '@fenderdigital/react-image';
import LevelIndicator from '../LevelIndicator';
import Link from '../Link';

function getChords(display, chords, containerStyle, itemStyle) {
  if (!display) return null;
  return (
    <div className={containerStyle}>
      {chords ? (
        <div className={itemStyle}>
          <span className="gray mr2">Chords</span>
          <span>{chords}</span>
        </div>
      ) : null}
    </div>
  );
}

function getContentImage(rowContent, styleObj) {
  const { image, trackEvent, url } = rowContent || {};
  const { aspectRatio, image: imgStyles, style } = styleObj || {};
  const images = getVariantUrls(image, aspectRatio, 'smallThumb');
  const ratio = getMapToRatios(aspectRatio);
  return (
    <Link className={`${style} mr3`} to={url} trackEvent={trackEvent || null}>
      <div className={`${imgStyles}`}>
        <Image images={images} ratio={ratio} />
      </div>
    </Link>
  );
}

function getContentText(display, content, style) {
  if (!display) return null;
  return <div className={style}>{content}</div>;
}

function getLessonsMessage(lessons) {
  return `${lessons} lesson${lessons && lessons > 1 ? 's' : ''}`;
}

function getLevelDisplay(display, level, style) {
  if (!display) return null;
  const levelNum = Number(level) || 1;
  return (
    <div className={style}>
      <LevelIndicator currentLevel={levelNum} levelFontSize="f6" completeColor="blue" />
    </div>
  );
}

function getTitle(curriculumInfo) {
  const { title, url, trackEvent, style = '', isSearch } = curriculumInfo;

  return (
    <Link className={`source-sans-b black ${style}`} to={url} trackEvent={trackEvent || null}>
      {isSearch ? <span dangerouslySetInnerHTML={{ __html: title }} /> : title}
    </Link>
  );
}

function getContentTitle(title, isSearch) {
  return isSearch ? <span dangerouslySetInnerHTML={{ __html: title }} /> : title;
}

export {
  getChords,
  getContentImage,
  getContentText,
  getLessonsMessage,
  getLevelDisplay,
  getTitle,
  getContentTitle,
};
